
    function initConfirmationTimer() {
        const timerElement = document.querySelector("#timer");
        const display = document.querySelector("#time");
        const expiredElement = document.querySelector("#expiredCodeTxt");

        if (!timerElement || !display || !expiredElement) {
            return;
        }

        const duration =
            Number.parseInt(timerElement.dataset.duration, 10) || 120;

        const resendUrl = timerElement.dataset.resendUrl;

        startConfirmationTimer(
            duration,
            display,
            timerElement,
            expiredElement,
            resendUrl
        );
    }


    function startConfirmationTimer(
        duration,
        display,
        timerElement,
        expiredElement,
        resendUrl
    ) {
        let remaining = duration;

        function render() {
            const minutes = Math.floor(remaining / 60);
            const seconds = remaining % 60;

            display.textContent =
                `${String(minutes).padStart(2, "0")}:` +
                `${String(seconds).padStart(2, "0")}`;
        }

        render();

        const interval = window.setInterval(async () => {
            remaining--;

            if (remaining < 0) {
                window.clearInterval(interval);

                timerElement.classList.add("d-none");
                expiredElement.classList.remove("d-none");

                await resendConfirmationCode(
                    resendUrl,
                    duration,
                    display,
                    timerElement,
                    expiredElement
                );

                return;
            }

            render();
        }, 1000);
    }


    async function resendConfirmationCode(
        resendUrl,
        duration,
        display,
        timerElement,
        expiredElement
    ) {
        if (!resendUrl) {
            console.error("Confirmation resend URL is missing.");
            return;
        }

        try {
            const response = await fetch(resendUrl, {
                method: "GET",
                headers: {
                    "X-Requested-With": "XMLHttpRequest",
                    "Accept": "application/json"
                }
            });

            if (!response.ok) {
                throw new Error(
                    `Unable to resend confirmation code (${response.status})`
                );
            }

            expiredElement.classList.add("d-none");
            timerElement.classList.remove("d-none");

            startConfirmationTimer(
                duration,
                display,
                timerElement,
                expiredElement,
                resendUrl
            );
        } catch (error) {
            console.error(
                "Unable to resend confirmation code:",
                error
            );
        }
    }


    initConfirmationTimer();